import Header from '../../components/admin/header/Header';
import SearchKeyword from '../../components/admin/common/SearchKeyword';
import Content from '../../components/admin/contact/Content';
import React, { useState, useEffect } from 'react';

export default function Contact() {
  const [searchParams, setSearchParams] = useState({});

  const handleSearch = (searchData) => {
    console.log('제휴문의 검색:', searchData);
    setSearchParams(searchData);
  };

  return (
    <>
      <Header></Header>
      <div className="content-wrapper">
        <div className="titleNav">제휴문의</div>

        <div className="">
          <SearchKeyword
            placeholder="제목을 입력하세요"
            searchType="title"
            onSearch={handleSearch}
          />
          <Content />
        </div>
      </div>
    </>
  );
}
